import ObjectStorage from './ObjectStorageService';
import StorageConstants from '../constants/StorageConstants';

export default {
  setAuthToken(token) {
    return ObjectStorage.setItem(StorageConstants.USER_INFO, { ...token });
  },
  getAuthToken() {
    const { accessToken } = ObjectStorage.getItem(StorageConstants.USER_INFO);
    return accessToken;
  },
  storeUserInfo(userInfo) {
    const current = ObjectStorage.getItem(StorageConstants.USER_INFO);
    return ObjectStorage.setItem(StorageConstants.USER_INFO, { ...current, ...userInfo });
  },
  removeUserInfo() {
    return ObjectStorage.setItem(StorageConstants.USER_INFO, {});
  },
  getUserName() {
    const { userName = '' } = ObjectStorage.getItem(StorageConstants.USER_INFO);
    return userName;
  },
  getUserMobile() {
    const { userMobile = '' } = ObjectStorage.getItem(StorageConstants.USER_INFO);
    return userMobile;
  },
  getUserID() {
    const { userId = '' } = ObjectStorage.getItem(StorageConstants.USER_INFO);
    return userId;
  },
  isSelfieSkipped() {
    const { isSelfieSkipped } = ObjectStorage.getItem(StorageConstants.IS_SELFIE_SKIPPED);
    return isSelfieSkipped;
  },
  setSelfieSkipped() {
    const current = ObjectStorage.getItem(StorageConstants.IS_SELFIE_SKIPPED);
    return ObjectStorage.setItem(StorageConstants.IS_SELFIE_SKIPPED, {
      ...current,
      isSelfieSkipped: true,
    });
  },
  getEmailId() {
    const { email } = ObjectStorage.getItem(StorageConstants.USER_INFO);
    return email;
  },
};
